import { useState } from 'react';

import { Box, Button, Flex } from '@opendoor/bricks/core';
import { IconX } from '@tabler/icons-react';

import useQueryParams from '../../helpers/queryParams';

const MaintenanceBanner = () => {
  const { maintenance_start_time_local } = useQueryParams();
  const [showBanner, setShowBanner] = useState(maintenance_start_time_local !== undefined);
  const closeBanner = () => setShowBanner(false);

  if (!showBanner) return null;

  return (
    <Flex
      py={[5, 5, 0]}
      pl={7}
      // @ts-expect-error custom yellow
      backgroundColor="#fff9e6"
      flexDirection="row"
      justifyContent={[null, null, 'space-between']}
      mx="auto"
    >
      <Box
        maxWidth="80%"
        p={[4, 4, 4, 7]}
        fontSize={['s1', 's1', 's1', 's2']}
        fontWeight="semibold"
      >
        Opendoor will be down for scheduled maintenance on {maintenance_start_time_local}
      </Box>
      <Button
        variant="ghost"
        onClick={closeBanner}
        id="maintenance-banner-close-button"
        aria-label="Close banner"
        analyticsName="cosmos-maintenance-banner-close"
        p={7}
      >
        <IconX size={16} aria-hidden="true" />
      </Button>
    </Flex>
  );
};

export default MaintenanceBanner;
